export const QUERY_KEYS = {
  EXTENSION_LIST_V1: "EXTENSION_LIST_V1",
  EXTENSION_LIST: "EXTENSION_LIST",
  EXTENSION_CONTACT_CENTER_LIST: "EXTENSION_CONTACT_CENTER_LIST",
  EXTENSION_CONTACT_CENTER_UNIT_LIST: "EXTENSION_CONTACT_CENTER_UNIT_LIST",
  EXTENSION_LIST_EXPORT: "EXTENSION_LIST_EXPORT",
  EXTENSION_DETAIL: "EXTENSION_DETAIL",
  EXTENSION_PASSWORD: "EXTENSION_PASSWORD",
  EXTENSION_SECRET_KEY: "EXTENSION_SECRET_KEY",

  PROVINCE_LIST: "PROVINCE_LIST",
  PROVINCE_TYPE_LIST: "PROVINCE_TYPE_LIST",
  PROVINCE_TYPE_EXTENSION_LIST: "PROVINCE_TYPE_EXTENSION_LIST",

  CONTACT_CENTER_LIST: "CONTACT_CENTER_LIST",

  AGENT_LIST: "AGENT_LIST",

  PHONE_NUMBER_LIST: "PHONE_NUMBER_LIST",
  PHONE_NUMBER_LIST_V1: "PHONE_NUMBER_LIST_V1",

  REPORT_INBOUND_PERFORMANCE: "REPORT_INBOUND_PERFORMANCE",
  REPORT_INBOUND_PERFORMANCE_EXPORT: "REPORT_INBOUND_PERFORMANCE_EXPORT",
  REPORT_EXTENSION: "REPORT_EXTENSION",
  REPORT_EXTENSION_EXPORT: "REPORT_EXTENSION_EXPORT",

  CALL_LOG_REPORT: "CALL_LOG_REPORT",
  REPORT_INBOUND_CALL_EXPORT: "REPORT_INBOUND_CALL_EXPORT",

  INBOUND_CALL_LOGS: "INBOUND_CALL_LOGS",
  INBOUND_CALL_LOGS_EXPORT: "INBOUND_CALL_LOGS_EXPORT",
  LIST_NUMBER_PBX: "LIST_NUMBER_PBX",
  INBOUND_CALL_LIST: "INBOUND_CALL_LIST",
  INBOUND_CALL_LIST_COUNT: "INBOUND_CALL_LIST_COUNT",
  INBOUND_CALL_LIST_EXPORT: "INBOUND_CALL_LIST_EXPORT",

  OUTBOUND_CALL_LOGS: "OUTBOUND_CALL_LOGS",
  OUTBOUND_CALL_LOGS_EXPORT: "OUTBOUND_CALL_LOGS_EXPORT",

  CITY_POST_OFFICE_LIST: "CITY_POST_OFFICE_LIST",
  DISTRICT_POST_OFFICE_LIST: "DISTRICT_POST_OFFICE_LIST",

  CAMPAIGN_LIST: "CAMPAIGN_LIST",

  BUSINESS_LIST: "BUSINESS_LIST",
  BUSINESS_LIST_EXPORT: "BUSINESS_LIST_EXPORT",
  BUSINESS_PHONE_NUMBER: "BUSINESS_PHONE_NUMBER",
  BUSINESS_PHONE_NUMBER_EXPORT: "BUSINESS_PHONE_NUMBER_EXPORT",
  BUSINESS_USER_LIST: "BUSINESS_USER_LIST",
  BUSINESS_EXTENSION_LIST: "BUSINESS_EXTENSION_LIST",
  BUSINESS_REPORT_LIST: "BUSINESS_REPORT_LIST",
  BUSINESS_REPORT_TYPE: "BUSINESS_REPORT_TYPE",
  BUSINESS_PBX_TYPE_LIST: "BUSINESS_PBX_TYPE_LIST",

  USER_LIST: "USER_LIST",
  USER_LIST_EXPORT: "USER_LIST_EXPORT",
  USER_LIST_COUNT: "USER_LIST_COUNT",
  USER_ROLE_LIST: "USER_ROLE_LIST",

  QUEUE_LIST: "QUEUE_LIST",
  QUEUE_LIST_COUNT: "QUEUE_LIST_COUNT",
  QUEUE_LIST_INFINITE: "QUEUE_LIST_INFINITE",
  QUEUE_DETAIL: "QUEUE_DETAIL",

  IVR_LIST: "IVR_LIST",
  IVR_LIST_COUNT: "IVR_LIST_COUNT",
  IVR_LIST_INFINITE: "IVR_LIST_INFINITE",
  IVR_DETAIL: "IVR_DETAIL",

  CALL_FLOW_LIST: "CALL_FLOW_LIST",
  CALL_FLOW_COUNT: "CALL_FLOW_COUNT",
  CALL_FLOW_DETAIL: "CALL_FLOW_DETAIL",

  REPORT_BUSINESS: "REPORT_BUSINESS",
  REPORT_BUSINESS_BCP: "REPORT_BUSINESS_BCP",
  REPORT_BUSINESS_CSKH: "REPORT_BUSINESS_CSKH",
  REPORT_DETAIL_INBOUND_CALL: "REPORT_DETAIL_INBOUND_CALL",
  REPORT_DETAIL_INBOUND_CALL_COUNT: "REPORT_DETAIL_INBOUND_CALL_COUNT",
  REPORT_DETAIL_INBOUND_CALL_EXPORT: "REPORT_DETAIL_INBOUND_CALL_EXPORT",
  REPORT_DETAIL_OUTBOUND_CALL: "REPORT_DETAIL_OUTBOUND_CALL",
  REPORT_DETAIL_OUTBOUND_CALL_COUNT: "REPORT_DETAIL_OUTBOUND_CALL_COUNT",
  REPORT_DETAIL_OUTBOUND_CALL_EXPORT: "REPORT_DETAIL_OUTBOUND_CALL_EXPORT",
  REPORT_DETAIL_FAILED_OUTBOUND_CALL: "REPORT_DETAIL_FAILED_OUTBOUND_CALL",
  REPORT_DETAIL_FAILED_OUTBOUND_CALL_EXPORT:
    "REPORT_DETAIL_FAILED_OUTBOUND_CALL_EXPORT",
  REPORT_DETAIL_FAILED_INBOUND_CALL: "REPORT_DETAIL_FAILED_INBOUND_CALL",
  REPORT_DETAIL_FAILED_INBOUND_CALL_EXPORT:
    "REPORT_DETAIL_FAILED_INBOUND_CALL_EXPORT",
  REPORT_OUTBOUND_CALL_BY_EXT: "REPORT_OUTBOUND_CALL_BY_EXT",
  REPORT_OUTBOUND_CALL_BY_EXT_EXPORT: "REPORT_OUTBOUND_CALL_BY_EXT_EXPORT",
  REPORT_OUTBOUND_CALL_BY_UNIT: "REPORT_OUTBOUND_CALL_BY_UNIT",
  REPORT_OUTBOUND_CALL_BY_UNIT_EXPORT: "REPORT_OUTBOUND_CALL_BY_UNIT_EXPORT",
  REPORT_INBOUND_CALL_BY_EXT: "REPORT_INBOUND_CALL_BY_EXT",
  REPORT_INBOUND_CALL_BY_EXT_EXPORT: "REPORT_INBOUND_CALL_BY_EXT_EXPORT",
  REPORT_INBOUND_CALL_BY_UNIT: "REPORT_INBOUND_CALL_BY_UNIT",
  REPORT_INBOUND_CALL_BY_UNIT_EXPORT: "REPORT_INBOUND_CALL_BY_UNIT_EXPORT",
  REPORT_CALL_ME_DINGDONG: "REPORT_CALL_ME_DINGDONG",
  REPORT_SYNTHESIS_FAILED_CALL: "REPORT_SYNTHESIS_FAILED_CALL",
  REPORT_SYNTHESIS_FAILED_CALL_EXPORT: "REPORT_SYNTHESIS_FAILED_CALL_EXPORT",
  REPORT_EXT_NOT_CALL: "REPORT_EXT_NOT_CALL",
  REPORT_EXT_NOT_CALL_EXPORT: "REPORT_EXT_NOT_CALL_EXPORT",
};
